<template>
  <ol class="black--text body-2">
    <li>Masih aktif di dalam Dapodik dalam semester berjalan (belum purna tugas)</li>
    <li>
      <span class="font-weight-medium font-italic">Diutamakan</span> memiliki pengalaman mengajar akumulasi minimal 5
      tahun
    </li>
    <li>Terdaftar di Dapodik</li>
    <li>Memiliki minat dan terlibat dalam pengembangan kurikulum di sekolah</li>
    <li>
      Memiliki ketertarikan pada pengembangan kompetensi guru dan kualitas pembelajaran di sekolah
    </li>
    <li>
      Terbiasa menggunakan platform belajar daring (google meet, zoom, dan aplikasi belajar daring lainnya)
    </li>
    <li>
      Memiliki laptop/ponsel yang dapat digunakan pada saat pelatihan daring
    </li>
    <li>
      Jumlah perwakilan yang diajukan:
      <ul>
        <li>1 orang pengawas sekolah</li>
        <li>
          2 orang perwakilan guru:
          <ul>
            <li>untuk jenjang SD (kelas 1 dan kelas 4)</li>
            <li>untuk jenjang SMP (kelas 7 dan kelas 8)</li>
            <li>untuk jenjang SMA (kelas 10 dan kelas 11)</li>
            <li>untuk SLB (disesuaikan dengan jenjang/ketunaan)</li>
            <li>
              Adapun 2 guru tersebut, terdiri dari:
              <span class="font-italic">
                1 guru adalah guru biasa, dan 1 guru BK atau akan ditentukan untuk mewakili sekolah mengikuti materi BK
              </span>
            </li>
          </ul>
        </li>
        <li>1 orang guru cadangan, jika ketersedian guru di sekolah kurang dari 2 maka tidak perlu cadangan</li>
      </ul>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'Instruksi',
};
</script>

<style scoped></style>
